/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, cvr: NonNullable<unknown>, address: NonNullable<unknown>, contact: NonNullable<unknown> }} Legal_CompanyInputs */

const da_legal_company = /** @type {(inputs: Legal_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}, CVR ${i?.cvr}, ${i?.address}. E-mail: ${i?.contact}.`)
};

/** @type {(inputs: Legal_CompanyInputs) => LocalizedString} */
const en_legal_company = da_legal_company;

/**

* @param {Legal_CompanyInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_company = /** @type {((inputs: Legal_CompanyInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_CompanyInputs, { locale?: "da" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_company(inputs)
	return da_legal_company(inputs)
});